/* eslint-disable max-len */
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DisplayService } from '../../services/display/display.service';
import { CommsService } from '../../services/comms/comms.service';
import { ConfigService } from '../../services/config/config.service';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { DataService } from '../../services/data/data.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';


@Component({
	selector: 'pcm-data-page-bcinvoice',
	templateUrl: './data-page-bcinvoice.component.html',
	styleUrls: ['./data-page-bcinvoice.component.scss']
})
export class DataPageBcinvoiceComponent implements OnInit {


	title = 'Blockchain Invoice Details';
	bcInvoiceDetails: any = {};
	dataConfig;
	dataObj = 'lineitem';
	tsColumsConfig = [];

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public configService: ConfigService,
		private commsService: CommsService,
		private displayService: DisplayService,
		private dataService: DataService,
		private invoiceService: InvoiceService,
		public timesheetService: TimesheetService
	) {
		this.dataConfig = this.configService.getDataObj(this.invoiceService.bcDataObj);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			this.loadBCInvoice(params['poNumber'], params['supplierId'], params['contractorUUID'], params['billingStart'], params['billingEnd'], params['invoiceType']);
		});
	}

	loadBCInvoice(poNumber, supplierId, contractorUUID, billingStart, billingEnd, invoiceType) {
		this.displayService.startLoading();
		const data = {
			ponumber: poNumber,
			supplierid: supplierId,
			billingstart: billingStart,
			billingend: billingEnd,
			invoicetype: invoiceType,
			contractoruuid: contractorUUID
		};

		this.commsService.getBlockchainInvoiceDetails(data).subscribe((res) => {
			console.log('GET INVOICE RECONCILIATION', res);
			this.bcInvoiceDetails = this.commsService.getSuccessData(res);
			this.invoiceService.parseItems(this.bcInvoiceDetails[this.configService.invoiceItemsProp], this.bcInvoiceDetails[this.configService.countryCodeProp]);
			this.dataService.updateBCInvoiceDetails(this.bcInvoiceDetails);
			this.tsColumsConfig = this.configService.getTableFields(this.timesheetService.dataObj, true, this.bcInvoiceDetails[this.configService.countryCodeProp]);
			this.timesheetService.selectDefaultTab(this.timesheetService.tabsData.bcinvoiceListTabs);

			this.displayService.endLoading();
		}, (err) => {
			this.displayService.endLoading();
			this.commsService.handleAPIError('GET INNVOICE RECONCILIATION', err);
			this.router.navigateByUrl('blockchain-invoices');
		});
	}
}
